import { array, func } from 'prop-types'
import { Spreadsheet, kuiperClassNames } from '@opallabs/kuiper'
import { getColumns } from './columns'
import './styles.scss'

export const StampManager = ({
  getCellContents,
  onDeleteStamp,
  onSetName,
  onViewStamp,
  stamps,
}) => (
  <div className={kuiperClassNames('stamp-manager')}>
    <Spreadsheet
      columns={getColumns(
        getCellContents,
        onSetName,
        onDeleteStamp,
        onViewStamp
      )}
      entities={stamps}
      displayHeader={true}
    />
  </div>
)

StampManager.propTypes = {
  getCellContents: func,
  onDeleteStamp: func,
  onSetName: func,
  onViewStamp: func,
  stamps: array,
}
